import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "display": "block",
    "position": "relative",
    "width": "100%",
    "max-height": "80vh",
    "overflow": "hidden",
    "overflow-y": "auto"
  }
};
import { onMounted, ref, watch } from 'vue';
import ProjectForm from './project-form.vue';
import { useProjectFormStore } from '@/stores';

import { useComponentModalInstance } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/share/hooks/common/index.js';
export default {
  __name: 'project-editor-form',
  props: {
    projId: {
      type: String,
      default: ''
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const projectFormRef = ref();
    const modalInst = useComponentModalInstance();
    const {
      createForm
    } = useProjectFormStore();
    const props = __props;
    onMounted(() => {
      modalInst.setConfirmButton({
        disabled: false
      });
    });
    const onOk = async () => {
      if (!projectFormRef.value) return false;
      const res = await projectFormRef.value.save();
      if (!res) return false;
      projectFormRef.value.resetForm();
      return res;
    };
    const onCancel = () => {};
    watch(() => props.projId, projId => {
      if (!projId) return;
      createForm(projId);
    }, {
      immediate: true
    });
    __expose({
      confirmListener: onOk,
      cancelListener: onCancel
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ProjectForm, {
        ref_key: "projectFormRef",
        ref: projectFormRef
      }, null, 512)]);
    };
  }
};